import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  ${p => p.theme.mq.upMd} {
    width: 50%;
  }

  ${p => p.theme.mq.upLg} {
    width: 33%;
  }
`

export const Inner = styled.div`
  position: absolute;
  top: ${em(-100)};
  bottom: ${em(-100)};
  left: 0;
  width: 100%;
  filter: url('#bacterias_filter');
`

export const Plug = styled.img`
  width: 100%;
  height: auto;
`

export const Unit = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  background: white;
`
